import React from 'react'

const debug = false
// const debug = "SelectMultiGenericValueEmpty"

export default function SelectMultiGenericValueEmpty(props) {
    let label = props.placeholder

    // check if all values option is enabled
    if (!!props.allValuesOption && !props.options) {
        label = props.allValuesOptionLabel
    }

    debug && console.log(debug, "render", label, props)

    const classes = Classes("ui5-field-form-editable dropdown-form h-36", props.className, {
        'ui5-txt-no-accent-default': !props.allValuesOption || !!props.options // for "Please select" label
    })

    return (
        <React.Fragment>
            <div className={classes} onClick={props.onClick}>
                {props.iconComponent}
                {label}
            </div>
            {props.children}
        </React.Fragment>
    )
}